import Vue from 'vue';

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

Vue.use(BootstrapVue, {
  "bootstrapCSS": false,
  "bootstrapVueCSS": false
});
Vue.use(BootstrapVueIcons);
